import { combineReducers } from "redux";

import * as actionTypes from "../actions/types";
import user from "./user";
import clinics from "./clinics";
import eclaim from "./eclaim";

const appReducer = combineReducers({
  user,
  clinics,
  eclaim
});

const rootReducer = (state, action) => {
  if (
    action.type === actionTypes.USER_LOGOUT ||
    action.type === actionTypes.APP_RESET
  ) {
    state = {};
  }
  return appReducer(state, action);
};

export default rootReducer;
